export default __webpack_public_path__ + "static/media/admin-giveaway.3123b476.png";